import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Select,
  UPLOAD,
  MAX_UPLOAD_SIZE,
  t,
  activeOptions,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { compressImageFile } from "../../utils/fileUpload";
import { can } from "../../utils/permission";

export default class BrandManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
        filter_search: "",
        filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,
      expanded_children: {},

        // Form States (Modal)
        uid: "",
        company_id: company?.id || "", // Default company_id
        brand_code: "",
        name: "",
        description: "",
        logo: "",
        is_active: "Active",

        // List Data
        data: [],
        data_brands: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count, data_brands = [];
    loading(true);

    // Call GET API Brands
    let [result, result_brands] = await Promise.all([
        GET("warehouse/brands", {
            page_size: 10,
            page: page,
            data_search: filter_search || "",
            is_active: this.state.filter_status || "",
        }),
        GET("warehouse/brands", {
            page_size: 100000,
            page: 0,
            data_search: filter_search || "",
            is_active: this.state.filter_status || "",
        }),
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }
    if (result_brands?.status) {
      data_brands = result_brands.data;
    }

    this.setState({ data: data || [], count, data_brands: data_brands || [] });
    loading(false);
  };

  // อัปโหลดโลโก้ยี่ห้อ (ยก pattern จาก warehouse/branches.js -> S3 แล้วเก็บเป็น URL)
  UploadLogo = async (file) => {
    if (!file) return;

    if (!file.type?.startsWith("image/")) {
      alert("", "warning", t("warning"), t("company_logo_hint"));
      return;
    }
    if (file.size > MAX_UPLOAD_SIZE.image) {
      alert("", "warning", t("warning"), t("company_logo_hint"));
      return;
    }

    loading(true);
    // บีบอัดแบบเดียวกับโลโก้สาขา (บีบไม่ได้ -> ใช้ไฟล์ต้นฉบับ)
    const compressed = await compressImageFile(file);
    const res = await UPLOAD(compressed, { folder: "brands/logos" });
    if (res?.status === true && res?.data?.file_path) {
      this.setState({ logo: res.data.file_path });
    } else {
      alert("", "warning", t("warning"), res?.message || `${t("upload")} ${t("fail")}`);
    }
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      brand_code,
      name,
      description,
      logo,
      parent_id,
      is_active,
    } = this.state;

    // Validation
    if (!brand_code.trim()) {
      alert("", "warning", t("warning"), t("verify_brand_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_brand_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Request Body
      let body = {
        company_id,
        brand_code,
        name,
        // ว่าง -> "-" : ให้ล้างคำอธิบายเดิมได้ (ดูคำอธิบายที่ logo)
        description: description || "-",
        // ไม่มีรูป -> "-" : placeholder ของ removeEmptyString (api.js) ที่ไม่ถูกตัดทิ้งและส่งถึง backend เป็น "" เพื่อให้ล้างรูปเดิมได้
        logo: logo || "-",
        parent_id: parent_id || "",
        level: parent_id ? 2 : 1,
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/brands", body)
        : await PUT("warehouse/brands/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/brands/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      brand_code: "",
      name: "",
      description: "",
      logo: "",
      parent_id: "",
      is_active: "Active",
    });
  };

  toggleChildren = (uid) => {
    this.setState((prevState) => ({
      expanded_children: {
        ...prevState.expanded_children,
        [uid]: !prevState.expanded_children[uid],
      },
    }));
  };

  flattenBrands = (brands = []) =>
    brands.reduce((acc, brand) => {
      acc.push(brand);
      if (brand.children?.length) {
        acc.push(...this.flattenBrands(brand.children));
      }
      return acc;
    }, []);

  render() {
    const {
      data,
      count,
      data_brands,
      expanded_children,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      brand_code,
      name,
      description,
      logo,
      is_active,
      parent_id
    } = this.state;
    const all_brands = this.flattenBrands(data_brands);

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("brand_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_brands_desc")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_brands")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{all_brands.length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                                    {"\uf02b"} {/* Tag icon for brand */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_brands")}</div>
                                    <h4 className="fw-bold text-success mb-0">{all_brands.filter((d) => d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_brands")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{all_brands.filter((d) => !d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_brands")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_status")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("brands.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_brand")}
                        </button>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Brands Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="ps-5 py-3 border-0 wpx-300">{t("brand")}</th>
                                    <th className="py-3 border-0 wpx-300">{t("description")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>

                            {data.map((item, idx) => (
                                <tbody key={item.uid || idx}>
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Brand Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <button
                                                    type="button"
                                                    className={`btn btn-link p-0 text-16 text-decoration-none d-inline-flex align-items-center justify-content-center wpx-32 hpx-16 ${item.children?.length > 0 ? "text-secondary pointer" : "text-secondary"}`}
                                                    onClick={() => item.children?.length > 0 && this.toggleChildren(item.uid)}
                                                    aria-label={expanded_children[item.uid] ? t("hide_children") : t("show_children")}
                                                    disabled={!item.children?.length}
                                                >
                                                    {item.children?.length > 0 ? (
                                                        <span className="icon fw-bold">
                                                            {expanded_children[item.uid] ? "\uf078" : "\uf054"}
                                                        </span>
                                                    ) : (
                                                        <span className="d-inline-block wpx-16 hpx-16" />
                                                    )}
                                                </button>
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf02b"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.brand_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Description */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "300px" }}>
                                                {item.description || "-"}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                {can("brands.update") && (
                                                <ActionIconButton
                                                    label={t("edit")}
                                                    icon={ACTION_ICONS.edit}
                                                    variant="warning"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            ...item,
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                />
                                                )}
                                                {can("brands.delete") && (
                                                <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                      {expanded_children[item.uid] && item.children?.map((child, cidx) => (
                                        <tr key={`${idx}-${cidx}`} className="border-bottom border-light">
                                            <td className="pe-3 bg-secondary-light" style={{ paddingLeft: "65px" }}>
                                                <div className="d-flex align-items-center">
                                                    <div
                                                        className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-secondary`}
                                                    >
                                                        <span className="icon">{"\uf02b"}</span>
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark text-14">{child.name}</div>
                                                        <div className="text-secondary text-10">
                                                            {t("code")}: {child.brand_code}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="bg-secondary-light">
                                                <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "300px" }}>
                                                    {child.description || "-"}
                                                </div>
                                            </td>
                                            <td className="text-center bg-secondary-light">
                                                {child.is_active ? (
                                                    <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                                ) : (
                                                    <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center bg-secondary-light">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    {can("brands.update") && (
                                                    <ActionIconButton
                                                        label={t("edit")}
                                                        icon={ACTION_ICONS.edit}
                                                        variant="warning"
                                                        onClick={() => {
                                                            this.setState({
                                                                modal_update: true,
                                                                ...child,
                                                                is_active: child.is_active ? "Active" : "Inactive",
                                                                parent_id: item.uid,
                                                            });
                                                        }}
                                                    />
                                                    )}
                                                    {can("brands.delete") && (
                                                    <ActionIconButton
                                                        label={t("delete")}
                                                        icon={ACTION_ICONS.delete}
                                                        variant="danger"
                                                        onClick={() => {
                                                            this.Delete(child.uid);
                                                        }}
                                                    />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ))}
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {count} {t("brands_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT BRAND */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_brand") : t("add_new_brand")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("brand_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("brand_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="e.g. B-01"
                                        value={brand_code}
                                        onChange={(e) => this.setState({ brand_code: e.target.value })}
                                        disabled={modal_update}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("brand_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control py-2" placeholder="e.g. brand-demo" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("parent_brand")}</label>
                                    <Select
                                        className="form-control"
                                        options={activeOptions(
                                            data_brands?.filter((b) => b.level === 1).map((b) => ({ is_active: b.is_active, value: b.uid, label: b.name })),
                                            parent_id
                                        )}
                                        placeholder={t("select_parent_brand")}
                                        value={parent_id}
                                        onChange={(e) => this.setState({ parent_id: e })}
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="3"
                                        placeholder={t("brand_description")}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("brand_logo")}</label>
                                    <div className="d-flex align-items-center gap-3">
                                        <div
                                            className="border rounded-3 d-flex align-items-center justify-content-center flex-shrink-0 bg-light overflow-hidden"
                                            style={{ width: "80px", height: "80px" }}
                                        >
                                            {logo ? (
                                                <img src={logo} alt="logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                            ) : (
                                                <span className="icon text-secondary text-20">{"\uf03e"}</span>
                                            )}
                                        </div>
                                        <div>
                                            <div className="d-flex gap-2">
                                                <label className="btn btn-white border px-3 py-1 rounded-3 fw-bold text-14 mb-0 pointer">
                                                    <span className="icon me-2">{"\uf093"}</span> {t("upload")}
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        hidden
                                                        onChange={(e) => {
                                                            const file = e.target.files?.[0];
                                                            e.target.value = "";
                                                            this.UploadLogo(file);
                                                        }}
                                                    />
                                                </label>
                                                {logo ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-white border text-danger px-3 py-1 rounded-3 fw-bold text-14"
                                                        onClick={() => this.setState({ logo: "" })}
                                                    >
                                                        {t("remove")}
                                                    </button>
                                                ) : null}
                                            </div>
                                            <small className="text-muted d-block mt-2">{t("company_logo_hint")}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="brandStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="brandStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {(this.state.modal_update ? can("brands.update") : can("brands.create")) && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
